import { render, staticRenderFns } from "./districts.vue?vue&type=template&id=7c724bd7&scoped=true&"
import script from "./districts.vue?vue&type=script&lang=js&"
export * from "./districts.vue?vue&type=script&lang=js&"
import style0 from "./districts.vue?vue&type=style&index=0&id=7c724bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c724bd7",
  null
  
)

export default component.exports